export type HomeViewProps = {
    data?: any;
}

export enum HomeViewTypes {
    AddKR,
    AddOP,
    UpdateKR,
    UploadGeometry
}